module.exports = __webpack_public_path__ + "static/media/inf_52pog53p.b6910e00.mp3";